"use client";

import { useEffect } from "react";

export default function MemberError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Member route error:", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <h1 className="mb-2 text-4xl font-bold text-white">
        Something went wrong
      </h1>
      <p className="mb-8 max-w-md text-base leading-relaxed text-grunge60 dark:text-grunge30">
        An error occurred while loading this page. Please try again.
      </p>
      <button
        onClick={reset}
        className="rounded-lg bg-purpleDub px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90"
      >
        Try again
      </button>
    </div>
  );
}
